import { FormattedMessage } from 'react-intl'
import {KTSVG} from '../../../../../../_metronic/helpers'
import {useListView} from '../../core/ListViewProvider'
import {PurchasedProductsListFilter} from './PurchasedProductsListFilter'

const PurchasedProductsListToolbar = () => {
  const {setItemIdForUpdate} = useListView()
  const openAddPurchasedProductModal = () => {
    setItemIdForUpdate(null)
  }

  return (
    <div className='d-flex justify-content-end' data-kt-purchasedproduct-table-toolbar='base'>
      <PurchasedProductsListFilter />

      {/* begin::Export */}
      <button type='button' className='btn btn-light-primary me-3'>
        <KTSVG path='/media/icons/duotune/arrows/arr078.svg' className='svg-icon-2' />
        <FormattedMessage id='TABLE.GENERAL.EXPORT' />      </button>
      {/* end::Export */}

      {/* begin::Add purchasedproduct */}
      <button type='button' className='btn btn-primary' onClick={openAddPurchasedProductModal}>
        <KTSVG path='/media/icons/duotune/arrows/arr075.svg' className='svg-icon-2' />
        <FormattedMessage id='PURCHASEDPRODUCT.TABLE.CREATEPURCHASEDPRODUCT' defaultMessage={"Create New"}/>
      </button>
      {/* end::Add purchasedproduct */}
    </div>
  )
}

export {PurchasedProductsListToolbar}
